module.exports = __webpack_public_path__ + "static/img/logo_white_bg.4b7691b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_white_bg.png
// module id = 603
// module chunks = 1